// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let IconV5 = require("../../../uikit/atoms/Icon/IconV5.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let JsxRuntime = require("react/jsx-runtime");

function SearchField(props) {
  let onChange = props.onChange;
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx("input", {
        className: "block flex-grow bg-white text-zinc-700 placeholder:text-zinc-500 placeholder:text-lg px-[15px] py-2.5 text-lg leading-5 border-0 outline-none focus:outline-none appearance-none rounded-none transition-colors duration-150 m-0",
        placeholder: props.placeholder,
        type: "search",
        value: props.value,
        onChange: e => Stdlib_Option.forEach(onChange, cb => cb(e))
      }),
      JsxRuntime.jsx("button", {
        children: JsxRuntime.jsx(IconV5.make, {
          icon: "search",
          size: 20,
          className: "text-zinc-400"
        }),
        className: "w-[42px] h-[42px] border-0 flex justify-center items-center shrink-0",
        type: "button"
      })
    ],
    className: "max-w-[500px] h-11 border border-zinc-300 hover:border-zinc-400 focus-within:border-tan-focused-border flex"
  });
}

let Icon;

let make = SearchField;

exports.Icon = Icon;
exports.make = make;
/* IconV5 Not a pure module */
